export const headerSlantContainerNoContent = () => {
    return {
        pt: { xs: "50px", sm: "50px", md: "65px" }, pb: { xs: "30px" }, color: 'white', textAlign: 'center'
    }
}